import { pipe } from "fp";
import { useEffect } from "react";
import { creator, reducer, type, useDispatch } from "~/Action";
import * as Driver from "~/Driver";
import * as Preferences from "~/Preferences";
import * as Company from "~/Company";
import { Remote } from "~/Remote";

// eslint-disable-next-line functional/prefer-readonly-type
export type Filter = number[];
// eslint-disable-next-line functional/prefer-readonly-type
export type BranchFilter = (number | Company.Company.Branch.NoBranchID)[];

export namespace State {
  export type State = Filter;
  export namespace Branch {
    export type State = BranchFilter;
    export const initial = (): State => [];
  }
  export const initial = (): State => [];
}

export const useWorkReportingLocationFilters = (): readonly [
  boolean,
  Filter
] => {
  const [
    driverLocationIDsLoading,
    driverWorkReportingLocationIds,
  ] = Remote.when(Preferences.Get.use<Filter>(), {
    loading: () => [true, []],
    error: () => [false, []],
    success: (preferences) => {
      return [false, preferences[Preferences.preferenceKey("locationFilter")]];
    },
  });
  return [driverLocationIDsLoading, driverWorkReportingLocationIds ?? []];
};

export const useFilteredDrivers = () => {
  const dispatch = useDispatch();

  const [
    reportingLocationIdsLoading,
    reportingLocationIDs,
  ] = useWorkReportingLocationFilters();

  const [
    branchIDsLoading,
    branchIDs,
  ] = Company.Company.Branch.Branches.useBranchFiltersFromPreferences();

  useEffect(() => {
    if (!reportingLocationIdsLoading && !branchIDsLoading) {
      dispatch(Action.Branch.Updated.create(branchIDs));
      dispatch(Action.Location.Updated.create(reportingLocationIDs));
      dispatch(Driver.Action.Filtered.Requested.create());
    }
  }, [reportingLocationIdsLoading, branchIDsLoading]);
};

export namespace Action {
  export namespace Location {
    export namespace Updated {
      export const { TYPE, create, reduce } = pipe(
        type("Drivers location filter updated" as const),
        creator((filter: Filter) => {
          return { filter };
        }),
        reducer(({ state, action: { filter } }) => {
          return (state.drivers.filter = filter);
        })
      );
    }
  }

  export namespace Branch {
    export namespace Updated {
      export const { TYPE, create, reduce } = pipe(
        type("Drivers branch filter updated " as const),
        creator((branchFilter: BranchFilter) => {
          return { branchFilter: branchFilter };
        }),
        reducer(({ state, action: { branchFilter } }) => {
          return (state.drivers.branchFilter = branchFilter);
        })
      );
    }
  }
}
